import createElement from '../logical-components/createElement';
import imageServiceUrlBuilder from '../core/utils/imageServiceUrl';
import './scss/media-card.scss';
var MediaCard = function (data) {
    var cardWrapper = createElement('div', [
        { type: 'class', value: '_mnslq-media-card' },
    ]);
    cardWrapper.addEventListener('click', function () {
        var _a;
        if ((_a = window === null || window === void 0 ? void 0 : window._mensenlinqEvents) === null || _a === void 0 ? void 0 : _a.emit) {
            window._mensenlinqEvents.emit('statistics', {
                type: 'actionsClicked',
                payload: {
                    time: Date.now(),
                    location: window.location.href,
                    service: data,
                },
            });
        }
    });
    cardWrapper.innerHTML = "<div class='_mnslq-media-card-media'>\n            <img src='".concat(imageServiceUrlBuilder(data.image), "' />\n            <div class='_mnslq-card-type'> ").concat(data.type, " </div>\n        </div>\n\n        <div class='_mnslq-media-card-content'>\n            <h3> ").concat(data.title, " </h3>\n            <p> ").concat(data.message, " </p>\n        </div>\n    ");
    return cardWrapper;
};
export default MediaCard;
